import * as Yup from "yup";

export const LoginwithEmailSchema = (
  emailrequire,
  validEmailRequire,
  passwordRequire
) => {
  return Yup.object().shape({
    email: Yup.string(emailrequire)
      .email(validEmailRequire)
      .required(emailrequire),
    password: Yup.string(passwordRequire).required()
  });
};

export const ForgotPasswordSchema = (emailrequire, validEmailRequire) =>
  Yup.object().shape({
    email: Yup.string(emailrequire)
      .email(validEmailRequire)
      .required(emailrequire)
  });

  export const RecoverPasswordSchema = (
    toShortValidation,
    toLongValidation,
    passwordValidation,
    comparePasswordValidation
  ) =>
    Yup.object().shape({
      new_password: Yup.string()
        .required(passwordValidation)
        .min(6, toShortValidation)
        .max(16, toLongValidation)
        ,
      repear_password: Yup.string().required(passwordValidation)
      .when("new_password", {
        is: val => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("new_password")],
          comparePasswordValidation
        )
      })
    });